export default {
  message: {
    "error": "Ocorreu um erro!",
    "Sorrysomeerrorsoccurred": "Desculpe, ocorreram alguns erros",
    "quit": "Sair",
    "language": "Idioma",
    "Youcanchangethelanguagehere": "Você pode alterar o idioma aqui!",
    "current": "Atual",
    "home": "Início",
    "friends": "amigos",
    "wallet": "Carteira",
    "aboutus": "Sobre Nós",
    "Sharewithfriends": "Compartilhar com amigos",
    "copyFailure": "Falha na cópia",
    "copySuccess": "Cópia bem-sucedida",
    "Claimreward": "Receber recompensa",
    "DailyLogin": "Login diário",
    "noInvitationsYet": "Sem convites ainda",
    "LoadMore": "Carregar mais",
    "WatchAD": "Assistir ANÚNCIO",
    "continue": "Continuar",
    "Congratulations": "Parabéns",
    "MyFriends": "Meus amigos",
    "Invitefriends": "Convide amigos",
    "Invitepremiumfriends": "Convide amigos premium",
    "DailyTasks": "Tarefas diárias",
    "inviteDesc": "+{num} ${name} por cada amigo que você convidar",
    "DailyTasksDesc": "Complete tarefas para ganhar mais ${name}",
    "SponsorsandPartners": "Patrocinadores e Parceiros",
    "Receivingwallet": "Carteira de recebimentos",
    "Enterwalletaddress": "Digite o endereço da carteira {name}",
    "Claim": "Receber",
    "Booster": "Acelerador",
    "RentPeriod": "Período de locação",
    "days30": "30 dias",
    "days": "dias",
    "Dailyprofit": "Lucro diário",
    "Totalprofit": "Lucro total",
    "Quantity": "Quantidade",
    "RentPrice": "Preço de locação",
    "RentMiner": "Locar Minerador",
    "Insufficient": "Saldo insuficiente ${name}",
    "InsufficientMsg": "{num} ${name1} necessário, convide amigos ou complete tarefas para ganhar mais ${name2}.",
    "Settings": "Configurações",
    "copyid": "Copiar ID",
    "UpgradeSuccessfully": "Atualização bem-sucedida",
    "Name": "Nome",
    "userinfo": "Informações do usuário",
    "disconnect": "Desconectar",
    "Startmining": "Começar a minerar",
    "Welcome": "Bem-vindo ao {name}",
    "Withdrawal": "Retirada",
    "Minimumamount": "Montante mínimo",
    "Networkfee": "Taxa de rede",
    "Enteramount": "Insira o valor",
    "Submit": "Enviar",
    "MinimumTip": "O valor de retirada é muito pequeno. Valor mínimo de retirada: {num}",
    "MaximumTip": "Valor insuficiente, o valor máximo que você pode retirar é: {num}",
    "SubmittedTip": "Submetido, espera-se que seja processado dentro de 30-60 dias úteis",
    "WithdrawStatus": "Status",
    "Submissiontime": "Hora da submissão",
    "WithdrawAwaitTip": "* Estima-se que levará de 30 a 60 dias úteis. Convidar mais amigos pode acelerar o processo de revisão.",
    "Processing": "Processando",
    "Amount": "Valor",
    "Numberoffriends": "Número de amigos: {now}/{limit}",
    "InviteTip": "Para fazer sua primeira retirada, você precisa convidar {limit} amigos para se juntar ao aplicativo de mineração.",
    "openonphone": "Abra este link no seu telefone.",
    "claimTip": "O valor a ser coletado é muito pequeno. O valor mínimo a ser coletado é: {num}",
    "WalletBalance": "Saldo da carteira",
    "Withdraw": "Retirar",
    "SetWalletAddress": "Definir Endereço da Carteira",
    "WithdrawalRecord": "Registro de Retirada",
    "Norecords": "Sem registros",
    "Whatis": "O que é {name}?",
    "All": "Todos",
    "save": "Salvar",
    "successWithdrawal": "A retirada foi recebida {num}",
    "secondsago": "{time} segundos atrás",
    "Loading": "Carregando...",
    "PaymentConfirming": "Verificando Status da Transação...",
    "Check": "Verificar",
    "CheckFail": "Transação não concluída. Por favor, verifique novamente em 5 segundos.",
    "Addname": "Adicionar '{name}' ao seu nome",
    "Restattcheck": "Reinicie o aplicativo para verificar",
    "Copyname": "Copiar '{name}'",
    "SubmissionFailed": "Falha na submissão, por favor, tente novamente mais tarde",
    "WithdrawalReview": "Revisão de Retirada",
    "WebWithdrawAwaitTip": "* Estima-se que levará de 24 a 48 horas. Convidar mais amigos pode acelerar o processo de revisão.",
    "Success": "Sucesso",
    "Rejection": "Rejeição",
    "WebSubmittedTip": "Submetido, espera-se que seja processado dentro de 24-48 horas",
    "shop": "Loja",
    "topurchase": "Vá à loja para comprar",
    "shopDesc": "Disponibilidade limitada—garanta a sua antes que desapareçam!",
    "claim": "Coletar",
    "payment_success": "Pagamento bem-sucedido",
    "payment_failed": "Pagamento falhou",
    "payment_cancelled": "Pagamento cancelado",
    "opening_payment": "Abrindo pagamento...",
    "payment_status": "Status do pagamento",
    "create_order_failed": "Falha ao criar pedido",
    "creating_ton_order": "Criando pedido TON...",
    "next_step": "Próximo passo",
    "use_ton_payment": "Usar pagamento TON",
    "start_transaction": "Iniciar transação",
    "connect_wallet": "Conectar carteira",
    "address": "Endereço",
    "amount_ton": "Quantidade TON",
    "copy": "Copiar",
    "amount": "Quantidade",
    "wallet_address": "Endereço da carteira",
    "comment_memo": "Comentário / memo",
    "you_can_choose_to_connect_wallet_to_pay": "Você pode escolher conectar a carteira para pagar",
    "or_manually_transfer_to_the_above_address": "Ou transferir manualmente para o endereço acima (observe que a quantidade e o memo devem ser exatamente os mesmos)",
    "transaction_success": "Transação bem-sucedida",
    "transaction_failed": "Transação falhou",
    "transaction_error": "Erro na transação",
    "transaction_status": "Status da transação",
    "transaction_id": "ID da transação",
    "transaction_amount": "Quantidade da transação",
    "transaction_status_desc": "Descrição do status da transação",
    "payment_status_tip": "Por favor, aguarde a confirmação do pagamento",
    "select_payment_method": "Selecionar método de pagamento",
    "total_amount": "Valor total",
    "creating_order": "Criando pedido...",
    "order_created": "Pedido criado",
    "order_status": "Status do pedido",
    "Applyforwithdrawal": "Solicitar saque",
    "Withdrawalunlock": "Desbloqueio de saque",
    "WithdrawalunlockTip": "Você precisa de {num} amigos convidados para completar tarefas/vincular carteiras para desbloquear o saque",
    "Close": "Fechar",
    "Delivering": "Entregando",
    "Duetothelargenumber": "Devido ao grande número de destinatários, seu airdrop deve chegar em 15-20 dias úteis",
    "select_network": "Selecionar rede",
    "confirm": "confirmar",
    "switching_network": "Trocando de rede...",
    "network_switched": "Rede trocada",
    "use_usdt_payment": "Utilize pagamento em USDT",
    "or_manually_transfer_to_the_above_address_usdt": "Transfira manualmente para o endereço acima (observe que a quantia e o endereço devem ser exatamente os mesmos)",
    "chain_type": "Rede",
    "check_transaction_status": "Verificar status da transação",
    "transaction_wait": "A transação está em processamento. Você pode sair do aplicativo. Uma mensagem o notificará assim que estiver completa.",
    "twa_pay_tip_with_memo": "Por favor, certifique-se de que o endereço, o valor e a mensagem são consistentes para a transferência.",
    "twa_pay_tip": "Por favor, certifique-se de que o endereço e o valor estão corretos para a transferência.",
    "creating_usdt_order": "Criando pedido USDT...",
    "affiliate_programs": "Programas de afiliados",
    "affiliate_programs_description": "Convide amigos para se juntar ao aplicativo de mineração e ganhar recompensas.",
    "commission_details": "Detalhes da comissão",
    "no_commission_records": "Nenhum registro de comissão",
    "commission_list": "Lista de comissões",
    "input_amount": "Insira o valor",
    "max": "Máx",
    "commission_input_amount": "Insira o valor da comissão",
    "min_commission": "O valor mínimo de retirada é {num}",
    "WithdrawalSuccess": "Retirada bem-sucedida",
    "WithdrawalFailed": "Retirada falhou",
    "WithdrawalProcessing": "Retirada em processamento",
    "award": "Prêmio",
    "level": "Nível",
    "Share_to_group": "Compartilhar no grupo",
    "Exchange": "Troca",
    "balance_not_enough": "Saldo insuficiente, você só pode trocar {num} {coin}",
    "exchange_fail": "Troca falhou",
    "exchange_success": "Troca bem-sucedida",
    "you_will_receive": "Você receberá",
    "ShareToGroups": "Compartilhar em grupos",
    "Numberofgroups": "Número de grupos: {now}/{limit}",
    "Confirm": "Confirmar",
    "ShareToGroupsDesc": "Compartilhe em grupos para ganhar mais {name}",
    "TokenAddress": "Por favor, insira os detalhes da retirada, como ID de troca ou endereço USDT",
    "CashAddress": "Por favor, insira os detalhes da retirada, como número do cartão bancário ou endereço USDT",
    "Cancel": "Cancelar",
    "min_withdrawal_amount": "O valor mínimo de retirada é {num} {coin}",
    "max_withdrawal_amount": "O valor máximo de retirada é {num} {coin}",
    "withdrawal_failed": "Retirada falhou",
    "withdrawal_success": "Retirada bem-sucedida",
    "PayNow": "Pague agora",
    "PaySkip": "Pague {num} para desbloquear a retirada instantaneamente",
    "NumberofGroups": "Número de grupos: {now}/{limit}",
    "SendMessage": "Enviar mensagem",
    "NumberofShares": "Número de ações: {now}/{limit}",
    "NumberofTasks": "Número de tarefas: {now}/{limit}",
    "CompleteTask": "Completar tarefa",
    "PleaseEnterValidAmount": "Por favor, insira um valor válido",
    "PleaseEnterValidEmail": "Por favor, insira um email válido",
    "Feedback": "Feedback",
    "Inputfeedbackcontent": "Insira o conteúdo do feedback",
    "Submitfeedback": "Enviar feedback",
    "Pleaseenteravalidemailaddress": "Por favor, insira um endereço de email válido",
    "Pleaseenteryouremailaddress": "Por favor, insira seu endereço de email",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "Você já enviou feedback hoje, por favor volte amanhã",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Feedback enviado com sucesso, obrigado pelo seu valioso feedback",
    "Feedback_submission_failed_please_retry": "Falha no envio do feedback, por favor tente novamente",
    "ContactUs": "Fale Conosco",
    "XRPAddress": "Por favor, preencha o endereço da carteira da cadeia XRP ativada (incluindo MEMO), caso contrário, você não conseguirá retirar dinheiro.",
    "Accelerated": "Acelerado",
    "Accelerated_withdrawals_success": "Retiradas aceleradas com sucesso",
    "login": "Entrar",
    "register": "Cadastrar",
    "login_with_google": "Entrar com Google",
    "or": "OU",
    "email": "Email",
    "password": "Senha",
    "no_account": "Não tem uma conta",
    "click_to_go": "Clique para",
    "have_account": "Já tem uma conta",
    "go_to": "Ir para",
    "invite_code": "Código de Convite",
    "optional": "Opcional",
    "google_login_not_ready": "Login com Google não está disponível, por favor tente novamente mais tarde",
    "password_too_long": "A senha é muito longa",
    "weak": "Fraca",
    "medium": "Média",
    "strong": "Forte",
    "login_success": "Login bem-sucedido",
    "login_failed": "Falha no login",
    "please_input_email": "Por favor, insira seu email",
    "invalid_email": "Formato de email inválido",
    "please_input_password": "Por favor, insira sua senha",
    "password_length_6_to_16": "A senha deve ter de 6 a 16 caracteres",
    "account_or_password_error": "Erro de conta ou senha",
    "register_success": "Cadastro bem-sucedido",
    "register_failed": "Falha no cadastro",
    "save_error": "Erro ao salvar, por favor tente novamente mais tarde",
    "ShareToFriends": "Compartilhar com amigos",
    "login_first": "Por favor, faça login primeiro",
    "WalletBscError": "❌ Endereço de carteira BNB Chain inválido.",
    "DownloadWallet": "Baixar Carteira",
    "AddToHomeScreen": "Adicionar {appName} à tela inicial",
    "TapShareInToolbar": "Toque na barra de ferramentas",
    "SelectAddToHomeScreen": "Selecione adicionar à tela inicial",
    "OpenToolbar": "Abrir barra de ferramentas",
    "ClaimFailed": "Receber recompensas falhou, por favor tente novamente mais tarde",
    "guest_login": "Login de Visitante",
    "please_input_phone": "Por favor, insira seu número de telefone",
    "email_error_1": "Por favor, insira seu email",
    "email_error_2": "Por favor, insira um endereço de email válido",
    "email_error_3": "Email de visitante não é permitido, por favor use um email verdadeiro",
    "phone": "Telefone",
    "phone_error_1": "Por favor, insira seu número de telefone",
    "phone_error_2": "Por favor, insira um número de telefone válido",
    "update_info": "Atualizar Informações",
    "update_success": "Atualização bem-sucedida",
    "update_failed": "Falha na atualização, por favor tente novamente mais tarde",
    "cancel": "Cancelar",
    "guest_credentials_title": "Informações da Conta",
    "guest_credentials_warning": "Por favor, tire uma captura de tela para salvar sua conta e senha. Se perdido, seus ganhos não poderão ser recuperados!",
    "i_have_saved": "Eu salvei",
    "account": "Conta",
    "view_credentials": "Ver Credenciais",
    "miner_max_reached": "Você atingiu o número máximo deste minerador"
}};